/* jshint undef: true, unused: true */

var notJquery = require('./not-jquery');

function isHiddenField(name) {
  return [
    'deviceType_equipmentform',
    'quantityUsed_equipmentform',
    'batchNumber_equipmentform',
    'expiryDate_equipmentform',
    'catalogueNumber_equipmentform',
    'operator_equipmentform',
    'usage_equipmentform',
    'currentLocationOfDevice_equipmentform',
  ].indexOf(name) > -1;
}

function getMessageName(name, foBuV) {
  const field = foBuV.getFieldStructure(name);
  // This is a hidden field populated by a visible field (e.g. administeredDrugId)
  // so the validation message needs to be displayed against the visible field
  return field && field.elementType === 'hidden' && field.populatedBy ? field.populatedBy + '_' + name.split('_')[1] : name;
}

function isMandatory(name, foBuV) {
  var rules = foBuV.rules[name];

  // If there are no rules, skip altogether.
  if (!rules) return false;

  // If all the validation types are falsey, it's not a mandatory field.
  if (Object.keys(rules).filter(validationType => rules[validationType]).length === 0) return false;

  // Stops it validating hidden fields.
  if (globals.spscFieldset && isHiddenField(name)) return false;

  return true;
}

// Checks whether a field is valid based on its name.
function isValid(name, foBuV) {
  const getRulesData = entry => {
    const [validationType, validationValue] = entry;
    return {
      type  : validationType,
      value : validationValue,
    };
  };
  const isInvalid = data => {
    const [element] = document.getElementsByName(name);
    if (!element) return false;
    return foBuV.ruleFns[data.type](element, data.value) === false;
  };
  return Object
    .entries(foBuV.rules[name])
    .map(getRulesData)
    .filter(isInvalid).length === 0;
}

module.exports = function FormBuilderValidation (foBu) {

  var nJ = notJquery,
      foBuV;

  function getFieldStructure(name, baseStructure) {
    var fieldStructure = baseStructure[name.split('_')[0]];

    // If the field structure is on the surface, return it.
    if (fieldStructure) return fieldStructure;

    // If it's deeper, we have to look through all the objects in the structure.
    return Object
      .keys(baseStructure)

      // Get all the child structures.
      .map(fieldName => baseStructure[fieldName].inputChildren)

      // Only process the ones which aren't undefined.
      .filter(childStructure => childStructure)

      // Run recursively against each child structure.
      .map(childStructure => getFieldStructure(name, childStructure))

      // Find the first field structure which isn't undefined.
      .find(childStructure => childStructure);
  }

  foBuV = {
    validationState : true,
    currentName     : null,
    currentElement  : null,
    validClass      : 'success',
    errorElement    : 'span',

    highlight       : function (element) {
      if (element && element.parentElement) {
        nJ.addClass(element, 'foBu__form-item--error');
      }
    },

    unhighlight  : function (element) {
      if (element && element.parentElement) {
        nJ.removeClass(element.parentElement, 'foBu__form-item--error');
      }
    },
    rules    : {},
    messages : {},

    validateElement:function(uid, name)
    {
      var rules = foBuV.rules[name];
      var elementIsValid = true;

      // If there are no rules, skip altogether.
      if (!rules) return true;

      // Stops it validating hidden fields.
      if (globals.spscFieldset && isHiddenField(name)) return true;

      var messageName = getMessageName(name, foBuV);

      foBuV.messageWrapper = document.getElementById(messageName + '__messageWrapper');
      foBuV.currentName    = messageName;

      foBuV.unhighlight(foBuV.messageWrapper);
      foBuV.clearMessages();
      foBuV.messages[messageName] = '';

      Object.keys(rules).forEach(function (validationType) {
        var validationValue = rules[validationType],
            element         = document.getElementsByName(name);

        if (element.length > 0) {
          element = element[0];

          if (foBuV.ruleFns[validationType](element, validationValue) === false) {
            foBuV.validationState = false;
            elementIsValid = false;
          }
          foBuV.showMessage();
        }else if (validationType === 'combo') {
          var comboInputsPresent = true;

          validationValue.forEach(function (elementName) {
            if (document.getElementsByName(elementName).length === 0){
              comboInputsPresent = false;
            }
          });

          if (comboInputsPresent) {
            if (foBuV.ruleFns[validationType](element, validationValue) === false) {
              foBuV.validationState = false;
              elementIsValid = false;
            }
          }
        }
      });

      return elementIsValid;
    },

    validityReport: function () {
      return Object
        .keys(foBuV.rules)
        .filter(name => {
          return isMandatory(name, foBuV);
        })
        .map(name => {
          return {
            valid         : isValid(name, foBuV),
            types         : Object.keys(foBuV.rules[name]),
            structure     : foBuV.getFieldStructure(name),
            isElementName : document.getElementsByName(name).length > 0,
            name,
          };
        });
    },

    validate : function (uid) {
      foBuV.validationState = true;
      foBuV.messages        = {};

      Object.keys(foBuV.rules).map(function (name) {
        foBuV.validateElement(uid, name);
      });

      return foBuV.validationState;
    },

    getInputElement : function (element) {
      if (element instanceof Element) {
        return element;
      }
      if (element.foBuSettings.inputElement && element.foBuSettings.inputElement instanceof Element) {
        return element.foBuSettings.inputElement;
      } else {
        console.error('Unable to get element for ', element);
      }

    },

    ruleFns        : {
      required  : function (element, validationValue) {
        var inputElement = foBuV.getInputElement(element),
            value        = inputElement.value;

        if (typeof value !== 'undefined' && value !== null && value.toString().length > 0) {
          return true;
        }
        if (validationValue) {
          var field = foBuV.getFieldStructure(element.name);
          if (field && field.elementType === 'hidden' && field.populatedBy) {
            // This is a required hidden field populated by a visible field (e.g. administeredDrugId)
            // so the validation message needs to be displayed against the visible field
            var name = field.populatedBy + '_' + element.name.split('_')[1],
                populatedByElement = document.getElementsByName(name);

            if (populatedByElement) {
              element = populatedByElement[0];
              // Blank the populated-by value to make it more obvious which data is missing
              element.value = '';
            }
          }

          if (element.foBuSettings) {
            foBuV.highlight(element.foBuSettings.domWrapper);
            foBuV.setMessage('required');
            return false;
          }
        }
      },
      minlength : function (element, validationValue) {
        var inputElement = foBuV.getInputElement(element),
            value        = inputElement.value;

        if (value.length >= validationValue) {
          return true;
        }
        foBuV.highlight(element.foBuSettings.domWrapper);
        foBuV.setMessage('minlength');
        return false;
      },
      email     : function (element, validationValue) {
        var inputElement = foBuV.getInputElement(element),
            value        = inputElement.value,
            rx           = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (rx.test(value)) {
          return true;
        }
        if (validationValue) {
          foBuV.highlight(element.foBuSettings.domWrapper);
          foBuV.setMessage('email');
          return false;
        }
      },
      combo : function(element, validationValue) {
        var allInputsHaveSetValue = true;

        validationValue.forEach(function (elementName) {
          var name         = foBu.getInputName(elementName),
              comboElement = foBu.targetElement.querySelector('[name="' + name + '"]'),
              inputElement = foBuV.getInputElement(comboElement),
              value        = inputElement.value;

          if (value.length === 0) {
            allInputsHaveSetValue = false;
          }
        });

        if (allInputsHaveSetValue === true) {
          return true;
        }

        foBuV.highlight(element.foBuSettings.domWrapper);
        foBuV.setMessage('required');
        return false;
      }
    },

    clearMessages  : function () {
      var messages = foBuV.messageWrapper;

      if (messages) {
        messages.innerHTML = '';
      }

    },

    setMessage     : function (type) {
      var structure = foBu.getPageStructure();

      if (typeof structure[foBuV.currentName] !== 'undefined' && typeof structure[foBuV.currentName].messages !== 'undefined' && structure[foBuV.currentName].messages[type]) {
        foBuV.messages[foBuV.currentName] += structure[foBuV.currentName].messages[type] + '<br>';
        return;
      }
      foBuV.messages[foBuV.currentName] += foBu.settings.defaultMessages[type] + '<br>';

      return;
    },

    showMessage    : function () {
      var messages = foBuV.messageWrapper;
      if (messages) {

        messages.innerHTML = foBuV.messages[foBuV.currentName];
      }
    },

    getFieldStructure: function(name) {
      return getFieldStructure(name, foBu.getPageStructure());
    },

    markRequired: function(id) {
      foBu.validation.rules[id].required = true;
    },

    markNotRequired: function(id) {
      if (!foBu.validation.rules[id]) {
          foBu.validation.rules[id] = {};
      }

      foBu.validation.rules[id].required = false;
    }
  };

  return foBuV;
};
